/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Mon Oct 28 2024
 **/

import { useRef } from "react";

import PartnerService from "../../PartnerService";

export default function withUser(events: API.Events) {
	const service = useRef(new PartnerService(events));
	return {
		user: {
			list: service.current.partnerAdmin.user.list,
			detail: service.current.partnerAdmin.user.detail,
			save: service.current.partnerAdmin.user.add,
			reset: service.current.partnerAdmin.user.reset_password,
			send: service.current.partnerAdmin.user.send_auth_mail,
			lock: service.current.partnerAdmin.user.update_lock,
			update: service.current.partnerAdmin.user.update,
			sampleDownload: service.current.partnerAdmin.user.download_sample,
			bulkRegistration: service.current.partnerAdmin.user.bulk_registration,
			delete: service.current.partnerAdmin.user.deleteUser
		},
		group: {
			groupList: service.current.partnerAdmin.user.group.list,
			detail: service.current.partnerAdmin.user.group.groupDetail,
			inquiryDelete: service.current.partnerAdmin.user.group.inquiryDelete,
			emailCheck: service.current.partnerAdmin.user.group.emailCheck,
			inquiryWithGroupKey: service.current.partnerAdmin.user.group.inquiryWithGroupKey,
			create: service.current.partnerAdmin.user.group.create,
			update: service.current.partnerAdmin.user.group.update,
			cancelInvite: service.current.partnerAdmin.user.group.cancelInvite,
			joinedList: service.current.partnerAdmin.user.group.joinedList,
			joinGroupWithGroupKey: service.current.partnerAdmin.user.group.joinGroupWithGroupKey,
			delete: service.current.partnerAdmin.user.group.delete,
			change: service.current.partnerAdmin.user.group.changeAdmin
		}
	};
}
